import { styled as styling } from "@mui/material/styles";
import ReactPlayer from "react-player/vimeo";

export const ReactPlayerStyled = styling(ReactPlayer)({
  objectFit: "cover",
  overflow: "hidden",

  height: "360px",
  width: "640px",

  "@media (max-width: 1280px)": {
    height: "270px",
    width: "480px",
  },
  "@media (max-width: 640px)": {
    height: "180px",
    width: "320px",
  },
});
